<template>
  <div id="app" class="app" :class="[$route.name, isGray ? 'gray' : '']">
    <Header v-show="$route.meta.commonHeader"></Header>
    <LogoSearch v-if="$route.meta.logoSearch"></LogoSearch>
    <LogoProcess v-if="$route.meta.recycleIndex"></LogoProcess>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
    <Footer v-show="$route.meta.commonFooter"></Footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Footer from './components/footer/footer';
import Header from './components/header/header';
import LogoSearch from './components/logo-search';
import LogoProcess from './components/logo-process';
import { themeSwitch } from '@/apis/base';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    LogoSearch,
    LogoProcess
  },
  computed: {
    ...mapState({
      gray: state => state.gray
    }),
    isGray () {
      return this.$route.name === 'Welcome' && this.gray === '1';
    }
  },
  methods: {
    async themeSwitch () {
      try {
        const res = await themeSwitch();
        if (res._errCode === '0') {
          this.$store.commit('setThemeGray', res._data.status || '0');
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted () {
    this.themeSwitch();
  }
};
</script>

<style>
@import '../../rootcss/base/base.css';
@import 'recover.css';

@media screen and (max-width: 1200px) {
  #app {
    width: 1200px !important;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all .2s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}

.gray {
  -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/App.vue